module.exports = __webpack_public_path__ + "img/penguin_crown.38dbddf1.svg";